import React, { useState } from 'react';
import Input, { InputProps } from './Input';
import { NativeSyntheticEvent, Platform, TextInputChangeEventData } from 'react-native';

export type TextAreaOwnProps = {};

export type TextAreaProps = TextAreaOwnProps & InputProps;

const TextArea: React.FC<TextAreaProps> = (props) => {
    const [height, setHeight] = useState<number | null>(null);

    const adjustTextInputSize = (evt: NativeSyntheticEvent<TextInputChangeEventData>) => {
        if (Platform.OS !== 'web') return;

        if (height !== null) {
            if (!evt.nativeEvent.text) {
                setHeight(0);
                return;
            }

            const el = (evt?.target || evt?.nativeEvent?.target) as any;

            if (el) {
                /*
                    allow for a quick recalculation of inner text height.

                    auto will set the height to a single line.
                    scrollHeight will give the full height of the text.
                    Adding 1 to the scrollHeight to prevent the scroll bar.
                    set the height to content-calculated height.

                    These quick updates don't seem to trigger react to re-render the component.

                    This will almost definitely not work on a native device.  Revisit if needed.
                */
                const originalHeight = el.style.height;
                el.style.height = 'auto';
                const newHeight = el.scrollHeight + 1;
                // only update if the height has changed by more than 3 pixels.  There can be some jitter while typing.
                if (Math.abs(newHeight - (height || 0)) > 3) {
                    setHeight(newHeight);
                    el.style.height = `${newHeight}px`;
                } else {
                    el.style.height = originalHeight;
                }
            }
        }
    };

    const platformSpecificProps = Platform.select<Partial<InputProps>>({
        web: {
            textInputStyle: { height: height || undefined },
            onChange: (e) => {
                adjustTextInputSize(e);
                props.onChange(e);
            },
            onContentSizeChange: (e) => {
                setHeight(e.nativeEvent.contentSize.height);
            },
        },
        default: {
            onChange: (e) => {
                props.onChange(e);
            },
        },
    });

    return <Input {...props} multiline {...platformSpecificProps} />;
};

export default React.memo(TextArea);
